import React, { useState } from 'react';

import { UiComponent, UserComponent } from 'components';
import { useIsMobile, usePageOption } from 'hooks';
import { UserQuery } from 'queries';
import { SearchUserFilterType } from 'types';

function DesktopList() {
  const pageState = usePageOption();
  const [filter, setFilter] = useState<SearchUserFilterType>({});

  const { data } = UserQuery.useGetAll({
    page: pageState.pageOption.page,
    size: pageState.pageOption.size,
    ...filter,
  });

  return (
    <UserComponent.List
      {...pageState}
      toolbar={
        <UserComponent.Filter filter={filter} handleFilter={setFilter} />
      }
      totalPage={data?.totalPages}
      data={data?.data || []}
    />
  );
}

function List() {
  const isMobile = useIsMobile();

  const title = <UiComponent.PageTitle>회원목록</UiComponent.PageTitle>;

  if (isMobile) return <UserComponent.MobileList title={title} />;

  return (
    <>
      {title}
      <DesktopList />
    </>
  );
}

export default List;
